import React, { useEffect, useRef, useState, useCallback } from 'react';
import './reportpage.css';
import { getSingleOrder } from "../apiService";
import PrintSlip from "../Components/printSlip";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";

const Report = ({ ReportData, onClose }) => {
  const [loadingOrderId, setLoadingOrderId] = useState(null); // loader per row
  const [orderPrintData, setOrderPrintData] = useState(null);
  const componentRef = useRef(null);

  // Printing events
  const handleAfterPrint = useCallback(() => {
    setOrderPrintData(null);
    setLoadingOrderId(null);
  }, []);

  const handleBeforePrint = useCallback(() => {
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "OrderSlip",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  /** 🔥 MAIN FUNCTION — PRINT USING order.order_number */
  const handleReprint = async (orderNumber) => {
    setLoadingOrderId(orderNumber);

    try {
      const response = await getSingleOrder(orderNumber);

      if (response.length > 0) {
        setOrderPrintData(response);
        toast.success("Reprinting order…", { autoClose: 800 });

        // Wait for PrintSlip to mount
        setTimeout(() => {
          if (componentRef.current) {
            printFn();
          }
        }, 800);
      } else {
        toast.error("Invalid Order Number!", { autoClose: 1000 });
      }
    } catch (error) {
      toast.error("Something went wrong!", { autoClose: 1000 });
    } finally {
      setLoadingOrderId(null);
    }
  };

  const closePopup = () => {
    onClose(false);
  };

  useEffect(() => {
    console.log("Report Data:", ReportData);
  }, [ReportData]);

  return (
    <div className=".main-container">
      <div className="popup-overlay">
        <div className="popup-container">
          <button className="close-btn" onClick={closePopup}>
            &times;
          </button>
          <h2>Report Details</h2>

          <div className="report-table-container">
            <table className="report-table">
              <thead>
                <tr>
                  <th className="report-table-header">Sr. No</th>
                  <th className="report-table-header">Order Number</th>
                  <th className="report-table-header">Total Invested</th>
                  <th className="report-table-header">Session Time</th>
                  <th className="report-table-header">Reprint</th>
                </tr>
              </thead>

              <tbody>
                {ReportData.map((order, index) => (
                  <tr key={order.id} className="report-table-row">
                    <td className="report-table-cell">{index + 1}</td>
                    <td className="report-table-cell">{order.order_number}</td>
                    <td className="report-table-cell">{order.total_invested_amount}</td>
                    <td className="report-table-cell">{order.session_time}</td>

                    <td className="report-table-cell">
                      <button
                        className="reprint-btn"
                        onClick={() => handleReprint(order.order_number)}
                        disabled={loadingOrderId === order.order_number}
                      >
                        {loadingOrderId === order.order_number
                          ? "Loading..."
                          : "Reprint"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* 🔥 Hidden print component */}
          <div style={{ display: "none" }}>
            {orderPrintData && (
              <PrintSlip orderData={orderPrintData} ref={componentRef} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report;
